import React, { useEffect, useState } from 'react';
import DenominationGrid from '../DenominationGrid';
import PinPad from '../PinPad';

export const ShiftOpenModal = ({
  isOpen,
  cashierName,
  defaultEmployeeId = '',
  onSubmit,
  loading,
  error
}) => {
  const [employeeId, setEmployeeId] = useState('');
  const [pin, setPin] = useState('');
  const [localError, setLocalError] = useState('');
  const [startingDenominations, setStartingDenominations] = useState({});
  const [startingTotal, setStartingTotal] = useState(0);

  useEffect(() => {
    if (!isOpen) return;
    if (defaultEmployeeId && !employeeId) {
      setEmployeeId(String(defaultEmployeeId));
    }
  }, [isOpen, defaultEmployeeId, employeeId]);

  if (!isOpen) return null;

  const handleOpenShift = async () => {
    setLocalError('');

    if (!employeeId.trim()) {
      setLocalError('Employee ID is required');
      return;
    }

    const pinString = String(pin).trim();
    if (pinString.length !== 4 || !/^\d{4}$/.test(pinString)) {
      setLocalError('PIN must be exactly 4 digits');
      return;
    }

    try {
      await onSubmit?.({
        employeeId: employeeId.trim(),
        pin: pinString,
        startingDenominations
      });
      setPin('');
    } catch {
      setPin('');
    }
  };

  return (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
      <div className="w-full max-w-lg rounded-xl bg-white p-6 shadow-2xl">
        <h2 className="text-xl font-bold text-gray-900">Start Shift</h2>
        <p className="mt-1 text-sm text-gray-600">Cashier: {cashierName || 'Cashier'}</p>

        <div className="mt-4 space-y-4">
          <div>
            <label className="mb-1 block text-sm font-semibold text-gray-700">Employee ID</label>
            <input
              type="text"
              value={employeeId}
              onChange={(event) => setEmployeeId(event.target.value)}
              className="w-full rounded-lg border border-gray-300 px-3 py-2"
              placeholder="Enter employee ID"
              autoFocus
              disabled={loading}
            />
          </div>

          <div>
            <label className="mb-1 block text-sm font-semibold text-gray-700">PIN</label>
            <PinPad value={pin} onChange={setPin} onSubmit={handleOpenShift} error={localError || error} />
          </div>

          <div>
            <label className="mb-2 block text-sm font-semibold text-gray-700">Starting Cash</label>
            <DenominationGrid
              columns={2}
              onChange={(denominations, total) => {
                setStartingDenominations(denominations);
                setStartingTotal(total);
              }}
            />
            <p className="mt-1 text-xs text-gray-500">Display total: ₱{startingTotal.toLocaleString()}</p>
          </div>

          {(localError || error) && (
            <p className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700">{localError || error}</p>
          )}

          <button
            type="button"
            onClick={handleOpenShift}
            disabled={loading || pin.length !== 4 || !employeeId.trim()}
            className="w-full rounded-lg bg-green-600 px-4 py-3 font-semibold text-white hover:bg-green-700 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {loading ? 'Opening Shift...' : 'Open Shift'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShiftOpenModal;
